import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var canCompress = function canCompress(event) {
  return event.actionSubject === 'feature' && event.action === 'exposed' && event.eventType === 'operational' && event.attributes && event.tags && event.tags.includes('measurement') && !event.tags.includes('hasCustomAttributes');
};
export var compressor = function compressor(events) {
  var batchSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
  if (!events || events.length <= 0) {
    return [];
  }
  if (batchSize <= 0) {
    throw new Error('Batch size must be greater than 0');
  }
  // Extract evaluations and reduce into a single array
  var flagEvaluations = events.map(function (currentEvent) {
    var _currentEvent$attribu = currentEvent.attributes,
      flagKey = _currentEvent$attribu.flagKey,
      value = _currentEvent$attribu.value,
      reason = _currentEvent$attribu.reason,
      ruleId = _currentEvent$attribu.ruleId,
      errorKind = _currentEvent$attribu.errorKind;
    return _objectSpread(_objectSpread(_objectSpread({
      key: flagKey,
      value: value
    }, reason && {
      reason: reason
    }), ruleId && {
      ruleId: ruleId
    }), errorKind && {
      errorKind: errorKind
    });
  });

  // Batch evaluations into specified batchSize
  return createBatches(flagEvaluations, batchSize);
};
var createBatches = function createBatches(array, batchSize) {
  var compressedEvaluations = [];
  for (var i = 0; i < array.length; i += batchSize) {
    var evaluationBatch = array.slice(i, i + batchSize);
    compressedEvaluations.push({
      actionSubject: 'features',
      action: 'exposed',
      eventType: 'operational',
      attributes: {
        evaluations: evaluationBatch
      },
      tags: ['measurement'],
      source: '@atlassian/exposure-events-compressor'
    });
  }
  return compressedEvaluations;
};
export var buildCompressionFunction = function buildCompressionFunction(batchSize) {
  return function (events) {
    return compressor(events, batchSize);
  };
};